import { getRewardsBalance } from "@utils/api"
import * as React from "react"

export default function useRewardsBalance(customerId?: string) {
  const [points, setPoints] = React.useState<number | undefined>(undefined)

  React.useEffect(() => {
    let active = true
    const run = async () => {
      if (!customerId) {
        return setPoints(undefined)
      }

      try {
        const res = await getRewardsBalance({ shopifyCustomerId: customerId })

        if (!active) {
          return
        }

        setPoints(res?.data?.balance?.available ?? 0)
      } catch {
        if (active) {
          setPoints(undefined)
        }
      }
    }
    run()
    return () => {
      active = false
    }
  }, [customerId])

  return points
}
